var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Loading, MessageBanner, Modal, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { FormattedMessage, useIntl } from "react-intl";
import { fetchTitleComparison, mergeTitles, previewTitleMerge, } from "../../../api/titleMergeService";
import { useTitleMergeCandidates } from "../../../hooks/useTitleMergeCandidates";
import { MAX_MERGE_SET_SIZE, MIN_MERGE_SET_SIZE, isAgencyTitle, } from "../../../types/titleMerge";
import { readMergeError } from "../../../utils/titleMergeErrors";
import { invalidateAfterTitleMerge } from "../../../utils/titleMergeQueries";
import { MergeCandidatePicker } from "./MergeCandidatePicker";
import { MergeComparisonTable } from "./MergeComparisonTable";
import { MergeImpactsPanel } from "./MergeImpactsPanel";
import css from "./MergeDuplicateTitles.module.css";
export var MergeDuplicateTitlesModal = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, onMerged = _a.onMerged, initialTitleIds = _a.initialTitleIds, titleType = _a.titleType, preferredSurvivorId = _a.preferredSurvivorId;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _c = useState([]), titleIds = _c[0], setTitleIds = _c[1];
    var _d = useState(null), pickedSurvivorId = _d[0], setPickedSurvivorId = _d[1];
    var _e = useState(""), search = _e[0], setSearch = _e[1];
    var _f = useState(null), notice = _f[0], setNotice = _f[1];
    // Callers build the initial set inline, so the effect keys off content, not array identity.
    var initialKey = initialTitleIds.join(",");
    useEffect(function () {
        var _a;
        setSearch("");
        setNotice(null);
        if (!open) {
            setTitleIds([]);
            setPickedSurvivorId(null);
            return;
        }
        var ids = initialKey ? initialKey.split(",") : [];
        setTitleIds(ids);
        setPickedSurvivorId((_a = preferredSurvivorId !== null && preferredSurvivorId !== void 0 ? preferredSurvivorId : ids[0]) !== null && _a !== void 0 ? _a : null);
    }, [open, initialKey, preferredSurvivorId]);
    var sortedIds = useMemo(function () { return __spreadArray([], titleIds, true).sort(); }, [titleIds]);
    var comparisonQuery = useQuery(["title-merge-comparison", sortedIds], function () { return fetchTitleComparison(kyInstance, titleIds); }, { enabled: open && titleIds.length > 0 });
    var comparison = useMemo(function () {
        var _a;
        var loaded = (_a = comparisonQuery.data) !== null && _a !== void 0 ? _a : [];
        return titleIds
            .map(function (id) { return loaded.find(function (title) { return title.id === id; }); })
            .filter(function (title) { return !!title; });
    }, [comparisonQuery.data, titleIds]);
    var agencyTitles = useMemo(function () { return comparison.filter(function (title) { return isAgencyTitle(title.source); }); }, [comparison]);
    var agencyTitle = agencyTitles.length === 1 ? agencyTitles[0] : undefined;
    var survivorId = useMemo(function () {
        var _a;
        if (agencyTitle)
            return agencyTitle.id;
        if (pickedSurvivorId && titleIds.includes(pickedSurvivorId)) {
            return pickedSurvivorId;
        }
        return (_a = titleIds[0]) !== null && _a !== void 0 ? _a : "";
    }, [agencyTitle, pickedSurvivorId, titleIds]);
    var duplicateIds = useMemo(function () { return titleIds.filter(function (id) { return id !== survivorId; }); }, [titleIds, survivorId]);
    var sortedDuplicateIds = useMemo(function () { return __spreadArray([], duplicateIds, true).sort(); }, [duplicateIds]);
    var hasEnoughTitles = titleIds.length >= MIN_MERGE_SET_SIZE;
    var previewQuery = useQuery(["title-merge-preview", survivorId, sortedDuplicateIds], function () { return previewTitleMerge(kyInstance, survivorId, duplicateIds); }, { enabled: open && hasEnoughTitles && !!survivorId, retry: false });
    var candidates = useTitleMergeCandidates(search, titleType, titleIds, open && titleIds.length < MAX_MERGE_SET_SIZE);
    var titleLabel = useCallback(function (id) {
        var _a, _b;
        var title = comparison.find(function (candidate) { return candidate.id === id; });
        if (!title)
            return id;
        var identifiers = title.identifiers.join(", ");
        return identifiers
            ? formatMessage({ id: "ui-br-legaldeposits.titleMerge.titleWithIdentifiers" }, { name: (_a = title.mainName) !== null && _a !== void 0 ? _a : "", identifiers: identifiers })
            : formatMessage({ id: "ui-br-legaldeposits.titleMerge.titleOnly" }, { name: (_b = title.mainName) !== null && _b !== void 0 ? _b : "" });
    }, [comparison, formatMessage]);
    var survivorName = useMemo(function () { var _a, _b; return (_b = (_a = comparison.find(function (title) { return title.id === survivorId; })) === null || _a === void 0 ? void 0 : _a.mainName) !== null && _b !== void 0 ? _b : ""; }, [comparison, survivorId]);
    var describeError = useCallback(function (code, status, titleIdsInError) {
        var titles = titleIdsInError.map(titleLabel).join(formatMessage({
            id: "ui-br-legaldeposits.titleMerge.titleSeparator",
        }));
        switch (code) {
            case "AGENCY_DUPLICATES":
                return {
                    type: "error",
                    text: formatMessage({ id: "ui-br-legaldeposits.titleMerge.error.agencyDuplicates" }, { titles: titles }),
                };
            case "AGENDA_CONFLICT":
                return {
                    type: "error",
                    text: formatMessage({ id: "ui-br-legaldeposits.titleMerge.error.agendaConflict" }, { titles: titles }),
                };
            case "SPECIAL_ISSUE_LINK_CONFLICT":
                return {
                    type: "error",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.specialIssueLinkConflict",
                    }, { titles: titles }),
                };
            case "SURVIVOR_MUST_BE_AGENCY":
                return {
                    type: "error",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.survivorMustBeAgency",
                    }, { titles: titles }),
                };
            case "PERIODICALS_NOT_SUPPORTED":
                return {
                    type: "error",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.periodicalsNotSupported",
                    }),
                };
            case "DIFFERENT_TITLE_TYPES":
                return {
                    type: "error",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.differentTitleTypes",
                    }, { titles: titles }),
                };
            case "PROVISIONAL_SURVIVOR":
                return {
                    type: "error",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.provisionalSurvivor",
                    }, { titles: titles }),
                };
            case "TOO_MANY_TITLES":
                return {
                    type: "default",
                    text: formatMessage({ id: "ui-br-legaldeposits.titleMerge.error.tooManyTitles" }, { max: MAX_MERGE_SET_SIZE }),
                };
            case "EMPTY_SELECTION":
            case "SELF_MERGE":
                return {
                    type: "error",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.selfMerge",
                    }),
                };
            case "PRODUCT_MAPPING_AMBIGUOUS":
                return {
                    type: "error",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.productMappingAmbiguous",
                    }),
                };
            case "MERGE_PREVIEW_STALE":
                return {
                    type: "warning",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.previewStale",
                    }),
                };
            case "TITLE_NOT_FOUND":
                return {
                    type: "error",
                    text: formatMessage({
                        id: "ui-br-legaldeposits.titleMerge.error.titleNotFound",
                    }),
                };
            default:
                break;
        }
        if (status === 409) {
            return {
                type: "warning",
                text: formatMessage({
                    id: "ui-br-legaldeposits.titleMerge.error.conflict",
                }),
            };
        }
        if (status === 403) {
            return {
                type: "error",
                text: formatMessage({
                    id: "ui-br-legaldeposits.titleMerge.error.forbidden",
                }),
            };
        }
        return {
            type: "error",
            text: formatMessage({
                id: "ui-br-legaldeposits.titleMerge.error.generic",
            }),
        };
    }, [formatMessage, titleLabel]);
    var refetchPreview = previewQuery.refetch;
    var handleMergeFailure = useCallback(function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var info;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, readMergeError(error)];
                case 1:
                    info = _a.sent();
                    if (info.code === "SURVIVOR_MUST_BE_AGENCY" && info.titleIds[0]) {
                        setPickedSurvivorId(info.titleIds[0]);
                    }
                    if (!(info.code === "MERGE_PREVIEW_STALE")) return [3 /*break*/, 3];
                    return [4 /*yield*/, refetchPreview()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    setNotice(describeError(info.code, info.status, info.titleIds));
                    return [2 /*return*/];
            }
        });
    }); }, [describeError, refetchPreview]);
    var mergeMutation = useMutation(function (variables) {
        return mergeTitles(kyInstance, variables.survivorId, variables.duplicateIds, variables.fingerprint);
    }, {
        onSuccess: function (plan, variables) {
            invalidateAfterTitleMerge(queryClient);
            onMerged({
                plan: plan,
                survivorId: variables.survivorId,
                survivorName: variables.survivorName,
                absorbedCount: variables.duplicateIds.length,
            });
            onClose();
        },
        onError: handleMergeFailure,
    });
    var previewError = previewQuery.error;
    var previewFailed = previewQuery.isError;
    useEffect(function () {
        if (!previewFailed)
            return undefined;
        var cancelled = false;
        readMergeError(previewError).then(function (info) {
            if (!cancelled) {
                setNotice(describeError(info.code, info.status, info.titleIds));
            }
        });
        return function () {
            cancelled = true;
        };
    }, [previewFailed, previewError, describeError]);
    var handleAdd = useCallback(function (id) {
        setNotice(null);
        setTitleIds(function (previous) {
            return previous.includes(id) || previous.length >= MAX_MERGE_SET_SIZE
                ? previous
                : __spreadArray(__spreadArray([], previous, true), [id], false);
        });
        setSearch("");
    }, []);
    var handleRemove = useCallback(function (id) {
        setNotice(null);
        setTitleIds(function (previous) { return previous.filter(function (titleId) { return titleId !== id; }); });
    }, []);
    var handlePickSurvivor = useCallback(function (id) {
        setNotice(null);
        setPickedSurvivorId(id);
    }, []);
    var isPreviewBlocking = hasEnoughTitles && (previewQuery.isFetching || previewQuery.isError);
    var confirmDisabled = !hasEnoughTitles ||
        comparisonQuery.isLoading ||
        isPreviewBlocking ||
        !((_b = previewQuery.data) === null || _b === void 0 ? void 0 : _b.fingerprint) ||
        mergeMutation.isLoading;
    var footer = (React.createElement("div", { className: css.footer },
        React.createElement("span", { className: css.footerInfo },
            React.createElement(FormattedMessage, { id: hasEnoughTitles
                    ? "ui-br-legaldeposits.titleMerge.footer.ready"
                    : "ui-br-legaldeposits.titleMerge.footer.needMore" })),
        React.createElement("div", { className: css.footerButtons },
            React.createElement(Button, { onClick: onClose, disabled: mergeMutation.isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" })),
            React.createElement(Button, { buttonStyle: "primary", disabled: confirmDisabled, onClick: function () {
                    var _a, _b;
                    setNotice(null);
                    mergeMutation.mutate({
                        survivorId: survivorId,
                        duplicateIds: duplicateIds,
                        fingerprint: (_b = (_a = previewQuery.data) === null || _a === void 0 ? void 0 : _a.fingerprint) !== null && _b !== void 0 ? _b : "",
                        survivorName: survivorName,
                    });
                }, "data-test-id": "merge-confirm" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.confirm", values: { count: titleIds.length } })))));
    return (React.createElement(Modal, { open: open, onClose: onClose, size: "large", dismissible: true, label: formatMessage({ id: "ui-br-legaldeposits.titleMerge.modalTitle" }), footer: footer },
        React.createElement("div", { className: css.modalContent, "data-test-id": "merge-modal" },
            React.createElement(MergeCandidatePicker, { search: search, onSearchChange: setSearch, candidates: candidates.candidates, isLoading: candidates.isCandidatesLoading, isSearchable: candidates.isSearchable, isTruncated: candidates.isTruncated, candidateLimit: candidates.candidateLimit, minSearchChars: candidates.minSearchChars, setIds: titleIds, isFull: titleIds.length >= MAX_MERGE_SET_SIZE, onAdd: handleAdd }),
            titleIds.length >= MAX_MERGE_SET_SIZE && (React.createElement(MessageBanner, { type: "default" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.error.tooManyTitles", values: { max: MAX_MERGE_SET_SIZE } }))),
            agencyTitle && (React.createElement(MessageBanner, { type: "default", "data-test-id": "merge-agency-lock" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.agencyLock" }))),
            notice && (React.createElement(MessageBanner, { type: notice.type, "data-test-id": "merge-notice" }, notice.text)),
            React.createElement("div", { className: css.sectionHeading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.comparison.heading", values: { count: titleIds.length, max: MAX_MERGE_SET_SIZE } }),
                React.createElement("span", { className: css.hint },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.comparison.hint" }))),
            comparisonQuery.isLoading && React.createElement(Loading, null),
            comparisonQuery.isError && (React.createElement(MessageBanner, { type: "error" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.comparison.failed" }))),
            comparison.length > 0 && (React.createElement(MergeComparisonTable, { titles: comparison, survivorId: survivorId, survivorLocked: !!agencyTitle, canRemove: titleIds.length > 1, onPickSurvivor: handlePickSurvivor, onRemove: handleRemove })),
            React.createElement("p", { className: css.hint },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.phaseOneNote" })),
            React.createElement(MergeImpactsPanel, { plan: previewQuery.data, isLoading: previewQuery.isFetching, isFailed: previewQuery.isError, hasEnoughTitles: hasEnoughTitles }),
            React.createElement(MessageBanner, { type: "warning" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.irreversible" })))));
};
